export default __webpack_public_path__ + "static/media/GR4 2A-2B-2EC.4463077d.jpg";